import React from "react";
import "./TagCloud.css";



const TagCloud = () => {
  return (
    <div className="whatsNew container--full">
      {/* <h3>Tag cloud</h3> */}
      <div className='container'>
        <div className="whatsNew-cloud">
          <p className="item-1">Multi-page Scrollable Bottom Sheet</p>
          <p className="item-2">Multi-Platform</p>
          <p className="item-3">Dart Null Safety</p>
          <p className="item-4">Dart</p>
          <p className="item-5">Flutter 2.8</p>
          <p className="item-6">web apps</p>
          <p className="item-7">Flutter widgets</p>
          <p className="item-8">Flutter SDK</p>
          <p className="item-9">Flame games</p>
          <p className="item-10">FlutterPlugin</p>
          <p className="item-11">State Management</p>
          <p className="item-12">go_router</p>
          <p className="item-13">OTT App</p>
          <p className="item-14">provider</p>
          <p className="item-15">google_fonts</p>
          <p className="item-16">shared_preferences</p>
        </div>
      </div>
    </div>
  );
};
export default TagCloud;
